import { FC, ReactNode, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import useCompanyDataState from '@/states/company-data.state';
import { CompanyDataSkeleton } from '@/pages/company-profile/company-data/CompanyDataSkeleton';

interface CompanyProfileCompleteGuardProps {
  children: ReactNode;
}

export const CompanyProfileCompleteGuard: FC<CompanyProfileCompleteGuardProps> = ({ children }) => {
  const navigate = useNavigate();
  const { tenant_id } = useParams();
  const { isCompanyProfileComplete, isLoading } = useCompanyDataState();

  useEffect(() => {
    if (!isLoading && !isCompanyProfileComplete) {
      // Redirect to company profile or data checklist if not complete
      navigate(`/${tenant_id}/data-perusahaan`, { replace: true });
    }
  }, [isCompanyProfileComplete, isLoading, navigate, tenant_id]);

  if (isLoading) {
    return (
      <section className="w-full">
        <div className="pt-5 px-5 pb-8">
          <CompanyDataSkeleton />
        </div>
      </section>
    );
  }

  if (!isCompanyProfileComplete) {
    return null;
  }

  return <>{children}</>;
};
